export interface ILogin {
  email: string;
  password: string;
}

export const LoginInitial: ILogin = {
  email: "",
  password: "",
};
